import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const animatedText = "NEXWYS";
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  // Typing animation
  useEffect(() => {
    let timer;
    if (index < animatedText.length) {
      timer = setTimeout(() => {
        setText((prev) => prev + animatedText[index]);
        setIndex(index + 1);
      }, 150);
    } else {
      timer = setTimeout(() => {
        setText("");
        setIndex(0);
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [index]);

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Background Video */}
      <iframe
        className="absolute top-0 left-0 w-full h-full scale-150 pointer-events-none"
        src="https://www.youtube.com/embed/qPl8Jt9GgHQ?autoplay=1&mute=1&loop=1&controls=0&playlist=qPl8Jt9GgHQ"
        title="Background Video"
        frameBorder="0"
        allow="autoplay"
      ></iframe>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center text-center px-4">
        <div className="text-white font-bold tracking-widest flex flex-col gap-6">
          <div className="text-lg md:text-3xl text-gray-200 font-medium">
            WELCOME TO
          </div>

          <div className="text-5xl md:text-7xl font-extrabold
              bg-gradient-to-r from-yellow-400 via-amber-400 to-yellow-600
              bg-clip-text text-transparent">
            {text}
            <span className="animate-pulse">|</span>
          </div>

          <p className="text-sm md:text-lg text-gray-200 max-w-2xl">
            We build modern websites, grow brands, and market your business digitally.
          </p>

          {/* CTA Buttons */}
          <div className="flex gap-4 mt-4 flex-wrap justify-center">
            <button
              onClick={() => navigate("/services")}
              className="px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold rounded-full transition duration-300"
            >
              Get Started
            </button>

            <button
              onClick={() => navigate("/contact")}
              className="px-6 py-3 border border-yellow-500 text-yellow-400 hover:bg-yellow-500 hover:text-black rounded-full transition duration-300"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
